export default __webpack_public_path__ + "static/media/logo.1dd97e43.png";